import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import type { GetCaseAssigneeCandidatesQuery } from './get-case-assignee-candidates.query';
import type { GetCaseAssigneeCandidatesResult } from './get-case-assignee-candidates.result';

@Injectable({ providedIn: 'root' })
export class GetCaseAssigneeCandidatesUseCase {
  private readonly _repository = inject(CasesRepository);

  public execute(query: GetCaseAssigneeCandidatesQuery): Observable<GetCaseAssigneeCandidatesResult> {
    return this._repository
      .getCaseAssigneeCandidates(query.caseId)
      .pipe(map((candidates) => ({ candidates })));
  }
}
